import React from 'react';

import { Nullable } from '@clearverify/types';
import { formatMoney } from '@clearverify/utils';

import { RevenueShareSettingFragment, RevenueShareType } from 'src/api';

export type RevenueShareSettingHost = {
  revenueShareSetting?: Nullable<RevenueShareSettingFragment>;
};

export const useRevenueShare = (entity: Nullable<RevenueShareSettingHost>) => {
  const revenueShareType = entity?.revenueShareSetting?.revenueShareType;
  const revenueShareValue =
    revenueShareType === RevenueShareType.Flat
      ? entity?.revenueShareSetting?.revenueShareFlat
      : entity?.revenueShareSetting?.revenueSharePercents;

  const revenueShareValueText = React.useMemo(() => {
    if (revenueShareType === RevenueShareType.Percents) {
      return `${revenueShareValue}%`;
    }

    if (revenueShareType === RevenueShareType.Flat) {
      return formatMoney(revenueShareValue);
    }

    return formatMoney(0);
  }, [revenueShareValue, revenueShareType]);

  return {
    revenueShareType,
    revenueShareValue,
    revenueShareValueText,
  };
};
